import { environment } from '@env/environment';
import { find, findIndex, remove } from 'lodash';
import { Static } from '../util/static';
import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { VitalRequestsConfigService } from './shared/view-vital-requests.config.service';
import { VitalRequestsViewDataService } from './shared/view-vital-requests.data.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Const } from '../util/constants';
import { Subject } from 'rxjs';
import { VistaSolicitudesVital } from '../models/solicitudes-vital.model';

@Component({
  selector: 'iw-view-vital-requests',
  templateUrl: './view-vital-requests.component.html',
  styleUrls: ['./view-vital-requests.component.scss'],
  providers: [VitalRequestsViewDataService]
})
export class VitalRequestsViewComponent implements OnInit, OnDestroy {
  
  // // Contiene la informacion de la vista dinamica
  @Input() viewStructure: VistaSolicitudesVital;
  // Mensaje de carga
  loadingMessage = '';
  // Define cuando se esta cargando la tabla de datos
  isLoading = false;
  // Define cuando la vista es filtrada por los tramites
  filterTramite = false;
  // Define las acciones en la vista
  actionsView = {
    init: false,
  };
  // Filas seleccionadas de la tabla
  selectedRows: number[] = [];
  // Contiene los registros consultados de la tabla
  data: any[] = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuración de la tabla
  settings = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;

  

  constructor(
    private dvds: VitalRequestsViewDataService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
      this.actionsView.init = true;
      this.selectedRows = [];
      this.loadStructureTable();
      this.loadDataSource();
      this.filterTramite = false;
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga de la informacion de la tabla
   *
   * @memberof VitalRequestsViewComponent
   */
  loadDataSource() {
    this.loadingMessage = 'Cargando las solicitudes para iniciar...';
    this.selectedRows = [];
    this.isLoading = true;
    this.dvds.getDataTables(this.viewStructure.id).subscribe(
      (data: any[]) => {
        this.data = Static.copyObjet(data);
        this.sourceData = new LocalDataSource(this.data);
        this.isLoading = false;
        this.loadingMessage = '';
      },
      (err: any) => {
        this.isLoading = false;
        this.loadingMessage = '';
      }
    );
  }

  /**
   * Controla la seleccion de registros en la tabla
   *
   * @param {*} data
   * @memberof VitalRequestsViewComponent
   */
  userRowSelect(data: any) {
    if(data){
    const existSelect = this.selectedRows.indexOf(data['data']['id']);
    if (existSelect > -1 && !data.isSelected) {
      this.selectedRows.splice(existSelect, 1);
    } else if(existSelect == -1 && data.isSelected) {
      this.selectedRows.push(data['data']['id']);
    }
    }
  }

  /**
   * Confirmacion para iniciar procesos de destino
   *
   * @param {boolean} [assignament=false]
   * @memberof VitalRequestsViewComponent
   */
  confirmInitProcess(assignament: boolean = false) {
    if (this.selectedRows.length) {
      let message = '';
      if (this.selectedRows.length > 1) {
        message = '¿Esta seguro de iniciar el trámite de la solicitudes seleccionadas?';
      } else {
        message = '¿Esta seguro de iniciar el trámite de la solicitud?';
      }
      this.confirmRef.new({
        question: message,
        labelConfirm: 'Sí',
        labelDecline: 'No'
      }).then(resp => {
        if (resp) {
          this.initProcess();
        }
      });
    } else {
      this.toastr.warning('Debe seleccionar al menos una solicitud de origen.', 'Información incompleta.');
    }
  }

  /**
   * Validacion para abrir modal de asignaciones
   *
   * @param {TemplateRef<any>} template
   * @param {boolean} [ignoreBackdropClick=true]
   * @param {string} [classModal='modal-lg']
   * @memberof VitalRequestsViewComponent
   */
  openConfirmModalAssignament(
    template: TemplateRef<any>,
    ignoreBackdropClick: boolean = true,
    classModal: string = 'modal-lg'
  ) {
    if (this.selectedRows.length) {
      this.openModal(template, ignoreBackdropClick, classModal);
    } else {
      this.toastr.warning('Debe seleccionar al menos un trámite de origen.', 'Información incompleta.');
    }
  }

  /**
   * Abrir una modal en el componente
   *
   * @param {TemplateRef<any>} template
   * @param {boolean} [ignoreBackdropClick=true]
   * @param {string} [classModal='modal-lg']
   * @memberof VitalRequestsViewComponent
   */
  openModal(template: TemplateRef<any>, ignoreBackdropClick: boolean = true, classModal: string = 'modal-lg') {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: classModal, ignoreBackdropClick: ignoreBackdropClick })
    );
  }

  /**
   * Carga de estructura de la tabla de la vista
   *
   * @private
   * @memberof VitalRequestsViewComponent
   */
  private loadStructureTable() {
    const configTable = new VitalRequestsConfigService();
    if (this.viewStructure.estructura.length) {
      this.viewStructure.estructura.sort((a, b) => a.orden - b.orden);
      this.viewStructure.estructura.forEach(structure => {
        let valid = true;
        if (valid) {
          configTable.generateColumn(structure.alias, structure.nombre);
        }
      });
    }
    this.settings = configTable.settings;
  }

  /**
   * Iniciar instancia de proceso de destino basado en procesos seleccionados
   *
   * @private
   * @memberof VitalRequestsViewComponent
   */
  private initProcess() {
    if (this.selectedRows.length > 1) {
      this.loadingMessage = 'Iniciando proceso';
    } else {
      this.loadingMessage = 'Iniciando procesos';
    }
    this.isLoading = true;
    this.dvds.initProcess(this.selectedRows).subscribe((_ressponse: any) => {
          this.isLoading = false;
          this.loadingMessage = '';
          this.loadDataSource();
        },
        (err: any) => {
          this.isLoading = false;
          this.loadingMessage = '';
        });
      
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/view-vital-requests/view-vital-requests.component.ts